module.exports = __webpack_public_path__ + "static/media/left-indent.20fb7cbf.svg";